import React from 'react';
import TextField from 'material-ui/TextField';

import { colors } from 'styles/provider';

const hintStyle = {
  color: colors.clrLabelLight,
  fontStyle: 'italic',
};

const MaterialTextField = ({ ...props }) => <TextField hintStyle={hintStyle} {...props} />;

export default MaterialTextField;
